import React, { useEffect, useState } from "react";
import {
  Alert,
  Button,
  createTheme,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Skeleton,
  Stack,
  Snackbar,
  TextField,
  Typography,
  Box,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import RateReviewRoundedIcon from "@mui/icons-material/RateReviewRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import NewsListTable from "./NewsListTable";
import { themeOptions, theming } from "../../theme";
import { ThemeProvider } from "@emotion/react";
import MainModal from "../MainModal";
import ComponentHeader from "../ComponentHeader";
import AnnouncementListTable from "../AnnouncementManagementComponent/AnnouncementListTable";
import { DropzoneArea } from "mui-file-dropzone";
import { useDispatch, useSelector } from "react-redux";
import {
  createNews,
  editNews as EditNewsAction,
  deleteNews,
  getNews,
} from "../../redux/actions/news-action";
import {
  createAnnouncement,
  editAnnouncement as EditAnnouncementAction,
  deleteAnnouncement,
  getAnnouncement,
} from "../../redux/actions/announcement-action";
import { create } from "@mui/material/styles/createTransitions";
import CircularProgress from "@mui/material/CircularProgress";
import ApiEndpoints from "../../utils/ApiEndpoints";
import { BASE_URL } from "../../constant/apiURL";
import { apiPut, fileUploadImage } from "../../utils/apiRequests";
import jwt_decode from "jwt-decode";

const useStyles = makeStyles((theme) => ({
  outlineInputBorder: {
    "& * > fieldset > legend": {
      display: "none",
    },
    "& > fieldset > legend > span": {
      display: "none",
    },
    "& * > input": {
      borderRadius: "1px",
      padding: "10px !important",
    },
    "& * > select": {
      padding: "3.5px !important",
    },
  },
  addIconButton: {
    background: "#2C633C !important",
    height: "30px",
    width: "30px",
  },
  searchBtn: {
    backgroundColor: "#2C633C !important",
    paddingRight: "20px !important",
    paddingLeft: "20px !important",
    height: "40px",
  },
  bottomIconButton: {
    color: "white",
  },
  iconBtn: {
    backgroundColor: "#2C633C !important",
    padding: 0,
    borderRadius: "10px !important",
  },
  addIcon: {
    color: "white",
  },
  inputLabel: {
    fontWeight: "bold !important",
    top: "5px",
  },
  button: {
    border: "1px solid transparent",
    "&:hover": {
      border: "1px solid #2C633C !important",
    },
  },
  modalDescription: {
    borderTop: "1px solid #cdcdcd !important",
    padding: "15px",
    marginTop: "20px",
    borderBottom: "1px solid #cdcdcd !important",
  },
}));

const initialAnnouncementState = {
  city_id: "",
  user_id: "",
  body: "",
  status: "active",
};

export default function NewList(props) {
  const classes = useStyles();
  const theme = createTheme(themeOptions);
  const [open, setOpen] = useState(false);
  const [openEditNewsModal, setOpenEditNewsModal] = useState(false);
  const [annoucementModalopen, setAnnoucementModalOpen] = useState(false);
  const [annoucementEditModalopen, setAnnoucementEditModalOpen] =
    useState(false);
  const [selectModalOpen, setSelectModalOpen] = useState(false);
  const [deleteVisible, setdeleteVisible] = useState(false);
  const [editVisible, seteditVisible] = useState(false);

  const [deleteAnnouncementVisible, setdeleteAnnouncementVisible] =
    useState(false);
  const [status, setStatus] = useState("Inactive");

  const [editNews, setEditNews] = useState(false);
  const [editNewsData, setEditNewsData] = useState({});
  const [selectedNewsrows, setselectedNewsrows] = useState([]);
  const [editAnnouncement, setEditAnnouncement] = useState(false);
  const [editAnnouncementData, setEditAnnouncementData] = useState({});
  const [selectedAnnouncementrows, setselectedAnnouncementrows] = useState([]);
  const [clearRow, setclearRow] = useState(false);
  const [pageRowsNews, setPageRowsNews] = useState(10);
  const [pageRowsAnnouncement, setPageRowsAnnouncement] = useState(10);
  const [editNewsMsg, setEditNewsMsg] = useState("");
  const [editNewsError, setEditNewsError] = useState({
    showAlert: false,
    msg: "",
  });
  const [editAnnouncementMsg, setEditAnnouncementMsg] = useState({
    showAlert: false,
    msg: "",
  });
  const [editAnnouncementError, setEditAnnouncementError] = useState({
    showAlert: false,
    msg: "",
  });
  const [openAlertEditNews, setOpenAlertEditNews] = useState(false);
  const [openAlertEditAnnouncement, setOpenAlertEditAnnouncement] =
    useState(false);
  const [openErrorEditAnnouncement, setOpenErrorEditAnnouncement] =
    useState(false);
  const newsImage = useSelector((state) => state?.newsReducer?.data);
  const [newsImageDefault, setNewsImageDefault] = useState("");

  const [newsTitle, setNewsTitle] = useState("");
  const [newsDescription, setNewsDescription] = useState("");
  const [announcementDescription, setAnnouncementDescription] = useState("");
  const [announcementStatus, setAnnouncementStatus] = useState("");
  const [newsAddStatus, setNewsAddStatus] = useState("");

  const [selectedModalVal, setSelectedModalVal] = useState("");

  const initialNewsState = {
    city_id: decodedToken?.city_id,
    user_id: decodedToken?.id,
    title: "",
    body: "",
    status: "",
  };

  const [newsState, setNewsState] = useState(initialNewsState);
  const [announcementState, setAnnouncementState] = useState(
    initialAnnouncementState
  );

  const [announcementAlert, setAnnouncementAlert] = useState(false);
  const [newsAlert, setNewsAlert] = useState(false);

  const [submitNews, setSubmitNews] = useState(false);
  const [submitAnnouncement, setSubmitAnnouncement] = useState(false);
  const [selectedNewsRow, setSelectedNewsRow] = useState();
  const [editNewsObj, setEditNewsObj] = useState();
  const [imageFile, setImageFile] = useState(editNewsObj?.picture);
  const [editAnnouncementObj, setEditAnnouncementObj] = useState();
  const [newsStatus, setNewsStatus] = useState();
  const [newsSwitchRow, setNewsSwitchRow] = useState({});
  const [announcementSwitchRow, setAnnouncementSwitchRow] = useState();

  const dispatch = useDispatch();

  const newsData = useSelector((state) => state?.newsReducer?.data);

  const [newsDataState, setNewsDataState] = useState();
  const newsDataRes = useSelector((state) => state?.newsReducer);

  const loadingnews = useSelector(
    (state) => state?.newsAnnouncementReducer?.isLoading
  );
  const announcementsData = useSelector(
    (state) => state?.announcementReducer?.data
  );
  const announcementDataRes = useSelector(
    (state) => state?.announcementReducer
  );

  const deleteAnnouncementRes = useSelector(
    (state) => state?.deleteAnnouncementReducer
  );

  var news = newsData;
  var announcements = announcementsData;
  const [newsSearchText, setNewsSearchText] = useState("");
  const [announcementSearchText, setAnnouncementSearchText] = useState("");

  const [switchNewsValue, setSwitchNewsValue] = useState();
  const [switchAnnouncementValue, setSwitchAnnouncementValue] = useState();

  const token = localStorage.getItem("token");
  var decodedToken = jwt_decode(token);

  const _handleChangeNewsTitle = (e) => {
    const { value } = e.target;
    setEditNewsObj({ ...editNewsObj, title: value });
  };

  const _handleChangeNewsBody = (e) => {
    const { value } = e.target;
    setEditNewsObj({ ...editNewsObj, body: value });
  };

  const _handleChangeAnnouncementBody = (e) => {
    const { value } = e.target;
    setEditAnnouncementObj({ ...editAnnouncementObj, body: value });
  };

  const onAnnouncementChangeDesc = (e) => {
    const { value } = e.target;
    setAnnouncementDescription(value);
  };

  const _handleChangeStatus = (item) => {
    setEditNewsObj({ ...editNewsObj, status: item });
  };

  const _handleChangeAnnouncementStatus = (item) => {
    setEditAnnouncementObj({ ...editAnnouncementObj, status: item });
  };

  const _handleChangeFileImages = (val) => {
    if (val.length >= 0) {
      fileUploadImage(
        `${ApiEndpoints.news.base}${ApiEndpoints.news.updateImage}${editNewsObj?._id}`,
        val[0]
      )
        .then((res) => {
          setImageFile(res?.picture);
        })
        .catch((err) => {
          console.log("err", err);
        });
    }
  };

  const file = new File([""], `${BASE_URL}${imageFile}`, {
    type: "text/plain",
  });

  if (newsSearchText) {
    news = newsData?.filter((val) => {
      if (
        val?.title?.toLowerCase().includes(newsSearchText.toLowerCase()) ||
        val?.body?.toLowerCase().includes(newsSearchText.toLowerCase())
      ) {
        return val;
      }
    });
  }

  if (announcementSearchText) {
    announcements = announcementsData?.filter((val) => {
      if (
        val?.body?.toLowerCase().includes(announcementSearchText.toLowerCase())
      ) {
        return val;
      }
    });
  }

  const getNewsList = () => {
    dispatch(getNews());
  };
  const getAnnouncementList = () => {
    dispatch(getAnnouncement());
  };
  useEffect(() => {
    getNewsList();
    getAnnouncementList();
  }, []);

  const openModal = () => {
    setOpen(true);
  };
  const closeModal = () => {
    setOpen(false);
    setNewsState(initialNewsState);
  };

  const onNewsChangeValue = (e, name) => {
    setNewsState((prevState) => ({ ...prevState, [name]: e }));
  };

  const onNewsAddTitle = (e) => {
    const { value } = e.target;
    setNewsTitle(value);
  };

  const onNewsAddDesc = (e) => {
    const { value } = e.target;
    setNewsDescription(value);
  };

  const clearNewsState = () => {
    setNewsState({ ...initialNewsState });
  };

  const onNewsEditPress = () => {
    if (selectedNewsrows?.length == 1) {
      setEditNews(!editNews);
    } else {
      alert("Please Select one item!");
    }
  };

  const [deleteRowData, setDeleteRowData] = useState(null);
  const onNewsSelectRow = (e) => {
    if (selectedNewsrows?.length != e?.selectedRows?.length) setEditNews(false);
    setselectedNewsrows(e?.selectedRows);
    setclearRow(false);
  };

  const validate = async () => {
    const isEmpty = Object.keys(newsState).some(function (x) {
      return newsState[x] === "" || newsState[x] === null;
    });
    if (isEmpty) {
      setSubmitNews(true);
      return false;
    } else {
      setSubmitNews(false);
      return true;
    }
  };

  const onNewsSubmit = async () => {
    const createNewsPayload = {
      city_id: decodedToken?.city_id,
      user_id: decodedToken?.id,
      title: newsTitle,
      body: newsDescription,
      status: newsAddStatus,
    };

    dispatch(createNews(createNewsPayload));
    setOpen(false);
    dispatch(getNews());
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  };

  const onNewsEditSubmit = () => {
    const editNewsSub = {
      city_id: editNewsObj?.city_id,
      user_id: editNewsObj?.user_id,
      title: editNewsObj?.title,
      body: editNewsObj?.body,
      status: editNewsObj?.status,
    };

    apiPut(
      `${ApiEndpoints.news.base}/${ApiEndpoints.news.update}${editNewsObj?._id}`,
      editNewsSub,
      (res) => {
        setEditNewsMsg(res?.message);
        setOpenAlertEditNews(true);
        setEditNews(false);
        getNewsList();
        getNewsList();
      },
      (err) => {
        // console.log("err", err);
        setEditNewsError({ showAlert: true, msg: err?.message });
      }
    );
  };

  const handleSwitchNews = (val, switchval) => {
    const newsSwitchPayload = {
      status: switchval,
    };

    apiPut(
      `${ApiEndpoints.news.base}${ApiEndpoints.news.update}${val?._id}`,
      newsSwitchPayload,
      (res) => {
        setEditNewsMsg(res?.message);
        setOpenAlertEditNews(true);
      },
      (err) => {
        // console.log("err", err);
        setEditNewsError({ showAlert: true, msg: err?.message });
      }
    );
  };

  const handleSwitchAnnouncement = (switchRow, switchVal) => {
    const announcementSwitchPayload = {
      status: switchVal,
    };

    apiPut(
      `${ApiEndpoints.announcement.base}/${ApiEndpoints.announcement.update}${switchRow?._id}`,
      announcementSwitchPayload,
      (res) => {
        setOpenAlertEditAnnouncement(true);
        setEditAnnouncementMsg({ showAlert: true, msg: res?.message });
      },
      (err) => {
        // console.log("err", err);
        setEditAnnouncementError({ showAlert: true, msg: err?.message });
      }
    );
  };

  const onNewsDeletePress = (row) => {
    setDeleteRowData(row);
    setdeleteVisible(true);
  };

  const onNewsDelete = async () => {
    dispatch(deleteNews(deleteRowData._id));
    getNewsList();
    getNewsList();
    getNewsList();
    getNewsList();

    setDeleteRowData(null);

    setdeleteVisible(false);
  };

  const onNewsEdit = async () => {
    dispatch(EditNewsAction(selectedNewsrows[0]?._id, selectedNewsrows[0]));
    seteditVisible(false);
    setEditNews(false);
  };

  const onAnnouncementChangeValue = (e, name) => {
    setAnnouncementState((prevState) => ({ ...prevState, [name]: e }));
  };

  const clearAnnouncementState = () => {
    setAnnouncementState({ ...initialAnnouncementState });
  };

  const onAnnouncementEditPress = () => {
    if (selectedAnnouncementrows?.length == 1) {
      setEditAnnouncement(!editAnnouncement);
    } else {
      alert("Please Select one item!");
    }
  };

  const onAnnouncementSelectRow = (e) => {
    if (selectedAnnouncementrows?.length != e?.selectedRows?.length)
      setEditAnnouncement(false);
    setselectedAnnouncementrows(e?.selectedRows);
    setclearRow(false);
  };

  const onAnnouncementSubmit = async () => {
    const createAnnouncementPayload = {
      city_id: decodedToken?.city_id,
      user_id: decodedToken?.id,
      body: announcementDescription,
      status: announcementStatus,
    };

    dispatch(createAnnouncement(createAnnouncementPayload));
    setAnnoucementModalOpen(false);
    dispatch(getAnnouncement());
  };

  const onAnnouncementEditSubmit = () => {
    const editAnnouncementPayload = {
      city_id: editAnnouncementObj?.city_id,
      user_id: editAnnouncementObj?.user_id,
      body: editAnnouncementObj?.body,
      status: editAnnouncementObj?.status,
    };

    apiPut(
      `${ApiEndpoints.announcement.base}/${ApiEndpoints.announcement.update}${editAnnouncementObj?._id}`,
      editAnnouncementPayload,
      (res) => {
        setOpenAlertEditAnnouncement(true);
        setEditAnnouncementMsg({ showAlert: true, msg: res?.message });
        setEditAnnouncement(false);
        getAnnouncementList();
        getAnnouncementList();
        getAnnouncementList();
      },
      (err) => {
        setEditAnnouncementError({ showAlert: true, msg: err?.message });
      }
    );
  };

  const onAnnouncementDeletePress = (row) => {
    setDeleteRowData(row);
    setdeleteAnnouncementVisible(true);
  };

  const onAnnouncementDelete = async () => {
    dispatch(deleteAnnouncement(deleteRowData?._id));
    setdeleteAnnouncementVisible(false);
    setDeleteRowData(null);
    getAnnouncementList();
    getAnnouncementList();
    getAnnouncementList();
  };

  const onAnnouncementEdit = async () => {
    dispatch(
      EditAnnouncementAction(
        selectedAnnouncementrows[0]?._id,
        selectedAnnouncementrows[0]
      )
    );
    seteditVisible(false);
    setEditAnnouncement(false);
  };

  const onChangeRowsPerPageNews = (e) => {
    setPageRowsNews(e);
  };

  const onChangeRowsPerPageAnnouncement = (e) => {
    setPageRowsAnnouncement(e);
  };

  const onChangeRadio = (e) => {
    const { value } = e.target;
    setSelectedModalVal(value);
  };

  const onSubmitSelectedModal = () => {
    if (selectedModalVal === "addNews") {
      setSelectModalOpen(false);
      setOpen(true);
    } else if (selectedModalVal === "addAnnouncement") {
      setSelectModalOpen(false);
      setOpen(false);
      setAnnoucementModalOpen(true);
    } else {
      setOpen(false);
      setAnnoucementModalOpen(false);
    }
  };

  useEffect(() => {
    setEditNewsData(editNewsData);
    setNewsDataState(newsData);
    setSwitchNewsValue(switchNewsValue);
  }, [
    editNews,
    editNewsData,
    newsStatus,
    selectedNewsRow,
    editAnnouncementMsg,
    newsImage,
    newsData,
    newsDataState,
    imageFile,
    announcementSwitchRow,
    switchAnnouncementValue,
    switchNewsValue,
  ]);

  return (
    <ThemeProvider theme={theme}>
      <Grid container>
        <Grid item xs={12} p={3}>
          <Grid item container>
            <Grid item xs={6} p="16px">
              <Snackbar
                open={openAlertEditNews}
                autoHideDuration={6000}
                onClose={() => setOpenAlertEditNews(false)}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
              >
                <Alert
                  onClose={() => setOpenAlertEditNews(false)}
                  severity="success"
                  sx={{ width: "100%" }}
                >
                  {editNewsMsg}
                </Alert>
              </Snackbar>

              <Snackbar
                open={openAlertEditAnnouncement}
                autoHideDuration={6000}
                onClose={() => setOpenAlertEditAnnouncement(false)}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
              >
                <Alert
                  onClose={() => setOpenAlertEditAnnouncement(false)}
                  severity="success"
                  sx={{ width: "100%" }}
                >
                  {editAnnouncementMsg?.msg}
                </Alert>
              </Snackbar>

              <Snackbar
                open={editNewsError?.showAlert}
                autoHideDuration={6000}
                onClose={() =>
                  setEditNewsError({ ...editNewsError, showAlert: false })
                }
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
              >
                <Alert
                  onClose={() =>
                    setEditNewsError({ ...editNewsError, showAlert: false })
                  }
                  severity="error"
                  sx={{ width: "100%" }}
                >
                  {editNewsError?.msg}
                </Alert>
              </Snackbar>

              <Snackbar
                open={openErrorEditAnnouncement}
                autoHideDuration={6000}
                onClose={() => setOpenErrorEditAnnouncement(false)}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
              >
                <Alert
                  onClose={() => setOpenErrorEditAnnouncement(false)}
                  severity="error"
                  sx={{ width: "100%" }}
                >
                  {editAnnouncementError?.msg}
                </Alert>
              </Snackbar>

              <Typography variant="h6" sx={{ fontWeight: 700 }}>
                News List
              </Typography>
            </Grid>
            <Grid item xs={6} p={2}>
              <ComponentHeader
                headerTitle="Announcements List"
                cbOpenModal={() => {
                  setSelectModalOpen(true);
                }}
                onSearch={(e) => {
                  setAnnouncementSearchText(e);
                  setNewsSearchText(e);
                }}
              />
            </Grid>
          </Grid>
          <Grid item container>
            {/* NEWS ACTIONS */}
            <Grid
              item
              xs={6}
              sx={{ display: "flex", justifyContent: "flex-end" }}
              pr={3}
              pb={2}
            >
              <Stack direction="row" spacing={1}>
                {editNews && (
                  <Button
                    onClick={() => seteditVisible(true)}
                    variant="contained"
                    size="small"
                  >
                    Save
                  </Button>
                )}
              </Stack>
            </Grid>

            {/* ANNOUNCEMENTS ACTIONS */}
            <Grid
              item
              xs={6}
              sx={{ display: "flex", justifyContent: "flex-end" }}
              pr={3}
              pb={2}
            >
              <Stack direction="row" spacing={1}>
                {editAnnouncement && (
                  <Button
                    onClick={() => seteditVisible(true)}
                    variant="contained"
                    size="small"
                  >
                    Save
                  </Button>
                )}
              </Stack>
            </Grid>
          </Grid>

          <Grid item container>
            {newsDataRes?.loading == false ? (
              <Grid item xs={6}>
                <NewsListTable
                  data={news || []}
                  progressPending={loadingnews}
                  progressComponent={<CircularProgress color="success" />}
                  clearRow={clearRow}
                  onSelectedRowsChange={onNewsSelectRow}
                  edit={editNews}
                  onChangeRowsPerPage={onChangeRowsPerPageNews}
                  selectedRow={selectedNewsrows}
                  setdeleteVisible={setdeleteVisible}
                  setEditNews={setEditNews}
                  editNews={editNews}
                  editNewsData={editNewsData}
                  setEditNewsData={setEditNewsData}
                  onNewsDeletePress={onNewsDeletePress}
                  setNewsAlert={setNewsAlert}
                  selectedNewsRow={selectedNewsRow}
                  setSelectedNewsRow={setSelectedNewsRow}
                  editNewsObj={editNewsObj}
                  setEditNewsObj={setEditNewsObj}
                  switchNewsValue={switchNewsValue}
                  setSwitchNewsValue={setSwitchNewsValue}
                  onChangeNewsSwitch={(e, sv) => handleSwitchNews(e, sv)}
                  newsSwitchRow={newsSwitchRow}
                  setNewsSwitchRow={setNewsSwitchRow}
                />
                {newsAlert ? (
                  <Alert severity="error">Select One Item</Alert>
                ) : (
                  ""
                )}
              </Grid>
            ) : (
              <Skeleton
                sx={{ margin: "15px" }}
                variant="rectangular"
                animation="wave"
                width={510}
                height={118}
              />
            )}
            {announcementDataRes?.loading == false ? (
              <Grid item xs={6}>
                <div style={{ borderLeft: "1px solid #C4C4C4" }}>
                  <AnnouncementListTable
                    data={announcements || []}
                    progressPending={loadingnews}
                    progressComponent={<CircularProgress color="success" />}
                    clearRow={clearRow}
                    onChangeRowsPerPage={onChangeRowsPerPageAnnouncement}
                    onSelectedRowsChange={onAnnouncementSelectRow}
                    edit={editAnnouncement}
                    editAnnouncementData={editAnnouncementData}
                    setEditAnnouncementData={setEditAnnouncementData}
                    selectedRow={selectedAnnouncementrows}
                    editNews={editNews}
                    setEditNews={setEditNews}
                    setEditAnnouncement={setEditAnnouncement}
                    selectedAnnouncementrows={selectedAnnouncementrows}
                    onAnnouncementDeletePress={onAnnouncementDeletePress}
                    setAnnouncementAlert={setAnnouncementAlert}
                    editAnnouncementObj={editAnnouncementObj}
                    setEditAnnouncementObj={setEditAnnouncementObj}
                    switchAnnouncementValue={switchAnnouncementValue}
                    setSwitchAnnouncementValue={setSwitchAnnouncementValue}
                    onChangeAnnouncementSwitch={(switchRow, switchVal) =>
                      handleSwitchAnnouncement(switchRow, switchVal)
                    }
                    announcementSwitchRow={announcementSwitchRow}
                    setAnnouncementSwitchRow={setAnnouncementSwitchRow}
                  />
                </div>
                {announcementAlert ? (
                  <Alert severity="error">Select One Item</Alert>
                ) : (
                  ""
                )}
              </Grid>
            ) : (
              <Skeleton
                sx={{ margin: "15px" }}
                variant="rectangular"
                animation="wave"
                width={510}
                height={118}
              />
            )}
          </Grid>

          {/* Select for what modal change */}
          <MainModal
            show={selectModalOpen}
            closeModal={() => setSelectModalOpen(false)}
            modalHeadTitle="Select Option Add News - OR - Add Announcement"
            btnLeftTitle="Cancel"
            btnRightTitle="OK"
            cb={() => setSelectModalOpen(false)}
            btnCloseModal={onSubmitSelectedModal}
            rightVariant="contained"
            leftVariant="outlined"
            sx={{ display: "none" }}
            width="900px"
          >
            <Divider />

            <RadioGroup
              sx={{ padding: "15px" }}
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
            >
              <FormControlLabel
                value="addNews"
                onChange={onChangeRadio}
                control={<Radio />}
                label="Add News"
              />
              <FormControlLabel
                value="addAnnouncement"
                onChange={onChangeRadio}
                control={<Radio />}
                label="Add Announcement"
              />
            </RadioGroup>
          </MainModal>

          {/* News Add Modal */}
          <MainModal
            show={open}
            closeModal={closeModal}
            modalHeadTitle="Create News"
            btnLeftTitle="Back"
            btnRightTitle="Save"
            cb={closeModal}
            btnCloseModal={() => onNewsSubmit()}
            leftVariant="outlined"
            rightVariant="contained"
            sx={{ display: "none" }}
            width="900px"
          >
            <Grid item container>
              <Grid item xs={12} mb={2}>
                <Stack spacing={1}>
                  <>
                    <InputLabel shrink className={classes.inputLabel}>
                      Title
                    </InputLabel>
                    <TextField
                      onChange={onNewsAddTitle}
                      value={newsTitle}
                      required
                      placeholder="Title"
                      className={classes.outlineInputBorder}
                      fullWidth
                      variant="outlined"
                      error={!newsState?.title && submitNews}
                      helperText={
                        !newsState?.title && submitNews
                          ? "Title is required"
                          : ""
                      }
                    />
                  </>
                  <>
                    <InputLabel shrink className={classes.inputLabel}>
                      Description
                    </InputLabel>
                    <TextField
                      onChange={onNewsAddDesc}
                      value={newsDescription}
                      required
                      placeholder="Description"
                      className={classes.outlineInputBorder}
                      fullWidth
                      variant="outlined"
                      multiline
                      rows={4}
                      error={!newsState?.body && submitNews}
                      helperText={
                        !newsState?.body && submitNews
                          ? "Description is required"
                          : ""
                      }
                    />
                  </>
                  <>
                    <InputLabel shrink className={classes.inputLabel}>
                      Status
                    </InputLabel>
                    <Select
                      variant="outlined"
                      value={newsAddStatus}
                      className={classes.outlineInputBorder}
                      name="status"
                      fullWidth
                      label="."
                      placeholder="Published"
                    >
                      {["published", "draft"].map((item) => (
                        <MenuItem
                          key={item}
                          value={item}
                          onClick={(e) => setNewsAddStatus(item)}
                        >
                          <Grid container item>
                            <Grid
                              fontStyle={{ textTransform: "capitalize" }}
                              item
                              xs={10}
                            >
                              {item}
                            </Grid>
                          </Grid>
                        </MenuItem>
                      ))}
                    </Select>
                  </>

                  <div>
                    <InputLabel shrink className={classes.inputLabel}>
                      Select Picture
                    </InputLabel>
                    <DropzoneArea
                      dropzoneText="Tap to upload"
                      showPreviews={false}
                      onChange={(e) => console.log("DropzoneArea", e)}
                    />
                  </div>
                </Stack>
              </Grid>
            </Grid>
          </MainModal>

          {/* News Edit Modal */}
          <MainModal
            show={editNews}
            closeModal={() => setEditNews(false)}
            modalHeadTitle="Edit News"
            btnLeftTitle="Back"
            btnRightTitle="Save"
            cb={() => setEditNews(false)}
            btnCloseModal={() => onNewsEditSubmit()}
            variant="outlined"
            rightVariant="contained"
            sx={{ display: "none" }}
            width="900px"
          >
            <Grid item container>
              <Grid item xs={12} mb={2}>
                <Stack spacing={1}>
                  <>
                    <InputLabel shrink className={classes.inputLabel}>
                      Title
                    </InputLabel>
                    <TextField
                      onChange={_handleChangeNewsTitle}
                      value={editNewsObj?.title}
                      required
                      placeholder="Title"
                      className={classes.outlineInputBorder}
                      fullWidth
                      variant="outlined"
                      error={!newsState?.title && submitNews}
                      helperText={
                        !newsState?.title && submitNews
                          ? "Title is required"
                          : ""
                      }
                    />
                  </>
                  <>
                    <InputLabel shrink className={classes.inputLabel}>
                      Description
                    </InputLabel>
                    <TextField
                      onChange={_handleChangeNewsBody}
                      value={editNewsObj?.body}
                      required
                      placeholder="Description"
                      className={classes.outlineInputBorder}
                      fullWidth
                      variant="outlined"
                      multiline
                      rows={4}
                      error={!newsState?.body && submitNews}
                      helperText={
                        !newsState?.body && submitNews
                          ? "Description is required"
                          : ""
                      }
                    />
                  </>
                  <>
                    <InputLabel shrink className={classes.inputLabel}>
                      Status
                    </InputLabel>
                    <Select
                      variant="outlined"
                      value={editNewsObj?.status}
                      className={classes.outlineInputBorder}
                      name="status"
                      fullWidth
                      label="."
                      placeholder="Published"
                    >
                      {["published", "draft"].map((item) => (
                        <MenuItem
                          key={item}
                          value={item}
                          onClick={() => {
                            _handleChangeStatus(item);
                          }}
                        >
                          <Grid container item>
                            <Grid
                              fontStyle={{ textTransform: "capitalize" }}
                              item
                              xs={10}
                            >
                              {item}
                            </Grid>
                          </Grid>
                        </MenuItem>
                      ))}
                    </Select>
                  </>

                  <div>
                    <InputLabel shrink className={classes.inputLabel}>
                      Select Picture
                    </InputLabel>
                    <DropzoneArea
                      dropzoneText="Tap to upload"
                      initialFiles={[
                        imageFile !== "" &&
                          `${BASE_URL}${editNewsObj?.picture}`,
                      ]}
                      showPreviews={false}
                      onChange={(e) => _handleChangeFileImages(e)}
                      filesLimit={1}
                      acceptedFiles={["image/*"]}
                    />
                  </div>
                </Stack>
              </Grid>
            </Grid>
          </MainModal>

          {/*  NEWS DELETE */}
          <MainModal
            show={deleteVisible}
            closeModal={() => setdeleteVisible(false)}
            modalHeadTitle="Delete"
            btnLeftTitle="Ok"
            btnRightTitle="Cancel"
            btnCloseModal={() => setdeleteVisible(false)}
            cb={() => onNewsDelete()}
            variant="contained"
            sx={{ display: "none" }}
            width="500px"
          >
            <Grid item container>
              <Grid item xs={12} mb={2}>
                <Stack spacing={1}>
                  <div className={classes.modalDescription}>
                    <p>
                      Are you sure, you want to Delete {deleteRowData?.name}
                    </p>
                  </div>
                </Stack>
              </Grid>
            </Grid>
          </MainModal>

          {/* EDIT MODAL */}
          <MainModal
            show={editVisible}
            closeModal={() => seteditVisible(false)}
            modalHeadTitle="Save"
            btnLeftTitle="Save"
            btnRightTitle="Cancel"
            btnCloseModal={() => seteditVisible(false)}
            variant="contained"
            sx={{ display: "none" }}
            width="500px"
            cb={() => {
              if (editNews) {
                onNewsEdit();
              } else {
                onAnnouncementEdit();
              }
            }}
          >
            <Grid item container>
              <Grid item xs={12} mb={2}>
                <Stack spacing={1}>
                  <div className={classes.modalDescription}>
                    <p> Are you sure, you want to Save?</p>
                  </div>
                </Stack>
              </Grid>
            </Grid>
          </MainModal>

          {/* Announcements Add Modal */}
          <MainModal
            show={annoucementModalopen}
            closeModal={() => setAnnoucementModalOpen(false)}
            modalHeadTitle="Create Announcement"
            btnLeftTitle="Back"
            btnRightTitle="Save"
            cb={() => {
              setAnnoucementModalOpen(false);
              setAnnouncementState(initialAnnouncementState);
            }}
            btnCloseModal={onAnnouncementSubmit}
            leftVariant="outlined"
            rightVariant="contained"
            sx={{ display: "none" }}
            btnRightsx={{ border: "1px solid #06623B" }}
            width="900px"
          >
            <Grid item container>
              <Grid item xs={12} mb={2}>
                <Stack spacing={1}>
                  <>
                    <InputLabel shrink className={classes.inputLabel}>
                      Description
                    </InputLabel>
                    <TextField
                      onChange={onAnnouncementChangeDesc}
                      required
                      placeholder="Description"
                      className={classes.outlineInputBorder}
                      fullWidth
                      variant="outlined"
                      multiline
                      rows={4}
                      error={!announcementState?.body && submitAnnouncement}
                      helperText={
                        !announcementState?.body && submitAnnouncement
                          ? "Description is required"
                          : ""
                      }
                    />
                  </>
                  <>
                    <InputLabel shrink className={classes.inputLabel}>
                      Status
                    </InputLabel>
                    <Select
                      variant="outlined"
                      value={announcementStatus}
                      className={classes.outlineInputBorder}
                      name="status"
                      fullWidth
                      label="."
                      placeholder="Inactive"
                    >
                      {["active", "inactive"].map((item) => (
                        <MenuItem
                          key={item}
                          value={item}
                          onClick={(e) => setAnnouncementStatus(item)}
                        >
                          <Grid container item>
                            <Grid
                              fontStyle={{ textTransform: "capitalize" }}
                              item
                              xs={10}
                            >
                              {item}
                            </Grid>
                          </Grid>
                        </MenuItem>
                      ))}
                    </Select>
                  </>
                </Stack>
              </Grid>
            </Grid>
          </MainModal>

          {/* Announcements Edit Modal */}
          <MainModal
            show={editAnnouncement}
            closeModal={() => setEditAnnouncement(false)}
            modalHeadTitle="Edit Announcement"
            btnLeftTitle="Back"
            btnRightTitle="Save"
            cb={() => {
              setEditAnnouncement(false);
            }} // =====>  this is called on back button
            btnCloseModal={onAnnouncementEditSubmit} // this is called on save button
            variant="outlined"
            rightVariant="contained"
            sx={{ display: "none" }}
            btnRightsx={{ border: "1px solid #06623B" }}
            width="900px"
          >
            <Grid item container>
              <Grid item xs={12} mb={2}>
                <Stack spacing={1}>
                  <>
                    <InputLabel shrink className={classes.inputLabel}>
                      Description
                    </InputLabel>
                    <TextField
                      onChange={_handleChangeAnnouncementBody}
                      value={editAnnouncementObj?.body}
                      required
                      placeholder="Description"
                      className={classes.outlineInputBorder}
                      fullWidth
                      variant="outlined"
                      multiline
                      rows={4}
                      error={!announcementState?.body && submitAnnouncement}
                      helperText={
                        !announcementState?.body && submitAnnouncement
                          ? "Description is required"
                          : ""
                      }
                    />
                  </>
                  <>
                    <InputLabel shrink className={classes.inputLabel}>
                      Status
                    </InputLabel>
                    <Select
                      variant="outlined"
                      value={editAnnouncementObj?.status}
                      className={classes.outlineInputBorder}
                      name="status"
                      fullWidth
                      label="."
                      placeholder="Inactive"
                    >
                      {["active", "inactive"].map((item) => (
                        <MenuItem
                          key={item}
                          value={item}
                          onClick={(e) => _handleChangeAnnouncementStatus(item)}
                        >
                          <Grid container item>
                            <Grid
                              fontStyle={{ textTransform: "capitalize" }}
                              item
                              xs={10}
                            >
                              {item}
                            </Grid>
                          </Grid>
                        </MenuItem>
                      ))}
                    </Select>
                  </>
                </Stack>
              </Grid>
            </Grid>
          </MainModal>

          {/*  Announcements DELETE */}
          <MainModal
            show={deleteAnnouncementVisible}
            closeModal={() => setdeleteAnnouncementVisible(false)}
            modalHeadTitle="Delete"
            btnLeftTitle="Ok"
            btnRightTitle="Cancel"
            cb={onAnnouncementDelete}
            btnCloseModal={() => setdeleteAnnouncementVisible(false)}
            variant="contained"
            sx={{ display: "none" }}
            width="500px"
          >
            <Grid item container>
              <Grid item xs={12} mb={2}>
                <Stack spacing={1}>
                  <div className={classes.modalDescription}>
                    <p> Are you sure, you want to Delete?</p>
                  </div>
                </Stack>
              </Grid>
            </Grid>
          </MainModal>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
}
